// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-container {
  padding: 10px 10px 20px 20px;
  max-width: 1000px;
  margin: 0 auto;
  background-color: #f5f5f5;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.add-trigger-button {
  background-color: #305e7a;
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 16px;
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 20px;
  transition: background-color 0.3s ease;
}

.add-trigger-button:hover {
  background-color: #dd6e25;
}

.trigger-table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

.trigger-table th,
.trigger-table td {
  padding: 12px 15px;
  text-align: left;
}

.trigger-table th {
  background-color: #305e7a;
  color: rgb(255, 255, 255);
  font-weight: bold;
  text-transform: uppercase;
  font-size: 14px;
}


.trigger-table td {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
  position: relative;
}


.trigger-table tr:last-child td {
  border-bottom: none;
}

.trigger-table tr:hover td {
  background-color: #f1f1f1;
}

.trigger-table-container {
  width: 100%;
  overflow-x: auto;
}


.edit-button,
.delete-button {
  background-color: #305e7a;
  color: white;
  border: none;
  padding: 5px 10px;
  font-size: 14px;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 5px;
  transition: background-color 0.3s ease;
}

.edit-button:hover {
  background-color: #dd6e25;
}

.delete-button {
  background-color: #741c25;
}

.delete-button:hover {
  background-color: #ac2936;
}

.edit-button-small {
  font-size: 12px;
  padding: 4px 8px;
  background-color: #007BFF;
  margin-top: 0;
  margin-left: auto;
  transform: translate(0%, 0%);
}

.delete-button-small {
  font-size: 12px;
  padding: 4px 8px;
  background-color: #741c25;
  margin-top: 0;
  margin-left: auto;
  transform: translate(0%, 0%);
}

.delete-button-small:hover {
  background-color: #ac2936;
}

.edit-button-small:hover {
  background-color: #0056b3;
}

/* Dashboard.css */

.status-button {
  font-size: 12px; 
  padding: 4px 8px; 
  border: none;
  border-radius: 5px; 
  cursor: pointer;
  color: white;
  transition: background-color 0.3s ease;
}

.status-button.active {
  background-color: #28a745; 
}

.status-button.inactive {
  background-color: #6e6e6e; 
}

.status-button:hover {
  opacity: 0.8;
}

/* Type filter icin */

.type-header {
  cursor: pointer;
  position: relative;
  background-color: #305e7a !important;
  color: rgb(255, 255, 255);
  display: flex;
  align-items: center;
  gap: 4px;
  padding-right: 25px !important;
}

.type-header::after {
  content: "▼";
  font-size: 12px;
  position: absolute;
  right: 8px;
  color: white;
  background-color: #305e7a !important;
}

.type-header:hover {
  background-color: #417ca0 !important;
  opacity: 0.8;
}

.type-dropdown {
  position: absolute;
  background-color: #305e7a; /* Darker background for better visibility - 0056b3 */
  color: white; /* White text for contrast */
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Slightly stronger shadow */
  border: 1px solid #427fb4; /* Gray border */
  border-radius: 4px;
  padding: 5px 0;
  z-index: 1000;
  width: 120px; /* Slightly wider dropdown */
  top: 100%;
  left: 0;
}

.type-dropdown div {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 14px;
}

.type-dropdown div:hover {
  background-color: #8493a1;
}

.delete-modal {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: white;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  outline: none;
}

.delete-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}

.delete-modal-content {
  text-align: center;
}

.delete-modal-content h3 {
  margin-top: 0;
  color: #333;
}

.delete-modal-buttons {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  gap: 10px;
}

.confirm-delete-btn {
  background: #741c25;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.cancel-delete-btn {
  background: #6c757d;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
}

.trigger-table th {
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  position: relative;
  padding-right: 20px;
}

.trigger-table th:hover {
  background-color: #417ca0;
}

.trigger-table th:not(.type-header)::after {
  content: '↕';
  position: absolute;
  right: 5px;
  opacity: 0.3;
}

.trigger-table th:not(.type-header):hover::after {
  opacity: 1;
}

/* Style for active sort column */
.trigger-table th[data-active='true'] {
  background-color: #356583;
  font-weight: bold;
  opacity: 0.5;
}

`, "",{"version":3,"sources":["webpack://./src/styles/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;AACjB;;;AAGA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;;AAGA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,aAAa;EACb,iBAAiB;EACjB,4BAA4B;AAC9B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,kBAAkB;;AAElB;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA,qBAAqB;;AAErB;EACE,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,yBAAyB,EAAE,qDAAqD;EAChF,YAAY,EAAE,4BAA4B;EAC1C,wCAAwC,EAAE,6BAA6B;EACvE,yBAAyB,EAAE,gBAAgB;EAC3C,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,YAAY,EAAE,4BAA4B;EAC1C,SAAS;EACT,OAAO;AACT;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA,iCAAiC;AACjC;EACE,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;AACd","sourcesContent":[".dashboard-container {\n  padding: 10px 10px 20px 20px;\n  max-width: 1000px;\n  margin: 0 auto;\n  background-color: #f5f5f5;\n  border-radius: 10px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.add-trigger-button {\n  background-color: #305e7a;\n  color: white;\n  border: none;\n  padding: 10px 20px;\n  font-size: 16px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-bottom: 20px;\n  transition: background-color 0.3s ease;\n}\n\n.add-trigger-button:hover {\n  background-color: #dd6e25;\n}\n\n.trigger-table {\n  width: 100%;\n  border-collapse: collapse;\n  margin-top: 20px;\n}\n\n.trigger-table th,\n.trigger-table td {\n  padding: 12px 15px;\n  text-align: left;\n}\n\n.trigger-table th {\n  background-color: #305e7a;\n  color: rgb(255, 255, 255);\n  font-weight: bold;\n  text-transform: uppercase;\n  font-size: 14px;\n}\n\n\n.trigger-table td {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  max-width: 140px;\n  position: relative;\n}\n\n\n.trigger-table tr:last-child td {\n  border-bottom: none;\n}\n\n.trigger-table tr:hover td {\n  background-color: #f1f1f1;\n}\n\n.trigger-table-container {\n  width: 100%;\n  overflow-x: auto;\n}\n\n\n.edit-button,\n.delete-button {\n  background-color: #305e7a;\n  color: white;\n  border: none;\n  padding: 5px 10px;\n  font-size: 14px;\n  border-radius: 5px;\n  cursor: pointer;\n  margin-right: 5px;\n  transition: background-color 0.3s ease;\n}\n\n.edit-button:hover {\n  background-color: #dd6e25;\n}\n\n.delete-button {\n  background-color: #741c25;\n}\n\n.delete-button:hover {\n  background-color: #ac2936;\n}\n\n.edit-button-small {\n  font-size: 12px;\n  padding: 4px 8px;\n  background-color: #007BFF;\n  margin-top: 0;\n  margin-left: auto;\n  transform: translate(0%, 0%);\n}\n\n.delete-button-small {\n  font-size: 12px;\n  padding: 4px 8px;\n  background-color: #741c25;\n  margin-top: 0;\n  margin-left: auto;\n  transform: translate(0%, 0%);\n}\n\n.delete-button-small:hover {\n  background-color: #ac2936;\n}\n\n.edit-button-small:hover {\n  background-color: #0056b3;\n}\n\n/* Dashboard.css */\n\n.status-button {\n  font-size: 12px; \n  padding: 4px 8px; \n  border: none;\n  border-radius: 5px; \n  cursor: pointer;\n  color: white;\n  transition: background-color 0.3s ease;\n}\n\n.status-button.active {\n  background-color: #28a745; \n}\n\n.status-button.inactive {\n  background-color: #6e6e6e; \n}\n\n.status-button:hover {\n  opacity: 0.8;\n}\n\n/* Type filter icin */\n\n.type-header {\n  cursor: pointer;\n  position: relative;\n  background-color: #305e7a !important;\n  color: rgb(255, 255, 255);\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding-right: 25px !important;\n}\n\n.type-header::after {\n  content: \"▼\";\n  font-size: 12px;\n  position: absolute;\n  right: 8px;\n  color: white;\n  background-color: #305e7a !important;\n}\n\n.type-header:hover {\n  background-color: #417ca0 !important;\n  opacity: 0.8;\n}\n\n.type-dropdown {\n  position: absolute;\n  background-color: #305e7a; /* Darker background for better visibility - 0056b3 */\n  color: white; /* White text for contrast */\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2); /* Slightly stronger shadow */\n  border: 1px solid #427fb4; /* Gray border */\n  border-radius: 4px;\n  padding: 5px 0;\n  z-index: 1000;\n  width: 120px; /* Slightly wider dropdown */\n  top: 100%;\n  left: 0;\n}\n\n.type-dropdown div {\n  padding: 8px 12px;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.type-dropdown div:hover {\n  background-color: #8493a1;\n}\n\n.delete-modal {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: white;\n  padding: 20px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  outline: none;\n}\n\n.delete-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.delete-modal-content {\n  text-align: center;\n}\n\n.delete-modal-content h3 {\n  margin-top: 0;\n  color: #333;\n}\n\n.delete-modal-buttons {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n  gap: 10px;\n}\n\n.confirm-delete-btn {\n  background: #741c25;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.cancel-delete-btn {\n  background: #6c757d;\n  color: white;\n  border: none;\n  padding: 8px 16px;\n  border-radius: 4px;\n  cursor: pointer;\n}\n\n.trigger-table th {\n  cursor: pointer;\n  user-select: none;\n  position: relative;\n  padding-right: 20px;\n}\n\n.trigger-table th:hover {\n  background-color: #417ca0;\n}\n\n.trigger-table th:not(.type-header)::after {\n  content: '↕';\n  position: absolute;\n  right: 5px;\n  opacity: 0.3;\n}\n\n.trigger-table th:not(.type-header):hover::after {\n  opacity: 1;\n}\n\n/* Style for active sort column */\n.trigger-table th[data-active='true'] {\n  background-color: #356583;\n  font-weight: bold;\n  opacity: 0.5;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
